(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/account-services/player-spelpaus.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/account-services/player-spelpaus.js');

'use strict';

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;


const getActiveSuspensionsAsync = async () => {
  try {
    const _await$drawgamesApiCa = await drawgamesApiCaller.getPlayerSuspensions(),
      response = _await$drawgamesApiCa.response,
      status = _await$drawgamesApiCa.status;
    if (status && status === 'success') {
      return response.suspensions.filter(suspension => suspension.product === 'quickGames' || suspension.product === 'all');
    }
    return [];
  } catch (error) {
    return [];
  }
};
async function playerSpelpaus(_ref) {
  let next = _ref.next,
    cancel = _ref.cancel,
    _ref$spelpausFlags = _ref.spelpausFlags,
    spelpausFlags = _ref$spelpausFlags === void 0 ? [] : _ref$spelpausFlags;
  const suspendedGames = await getActiveSuspensionsAsync();
  if (suspendedGames.find(_ref2 => {
    let product = _ref2.product;
    return spelpausFlags.indexOf(product) + 1;
  })) {
    svs.tur.apierrors.showErrorMessage({
      response: 1019,
      onConfirm: cancel
    });
  } else {
    next();
  }
}
svs.tur.pay.account_services.playerSpelpaus = playerSpelpaus;
svs.tur.pay.account_services.playerSpelpaus.CONSTANTS = {
  ALL: 'all',
  QUICK_GAMES: 'quickGames'
};

 })(window);